export enum CustomerPOStatus {
  RequiredPending = 'Required - Pending', RequiredAttached = 'Required - Attached', NotRequired = 'Not Required',
                                          Empty = '',
}
